module.exports = __webpack_public_path__ + "static/slide-4e82c0daf9bb0c69561edb581978c520.svg";